import { OrganizationList } from "@clerk/react";

export const NoOrg: React.FC = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background px-4">
      <OrganizationList
        hidePersonal
        skipInvitationScreen
        afterCreateOrganizationUrl="/"
        afterSelectOrganizationUrl="/"
      />
    </div>
  );
};
